import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/properties')({
  component: undefined,
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: 'breadcrumbs.properties',
    }),
  }),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/registry/properties') {
      throw redirect({
        to: '/dashboard/properties',
      });
    }
  },
});
